<template>
  <!-- Después de enviar el formulario de contacto: ofrece adelantar el trámite con el encargo online.
       Ref: https://trello.com/c/dw0OSYpA. Solo sale si el encargo online está activo. -->
  <div v-if="acceso.activa.value" class="adelantar-tramite">
    <strong>{{ t('Puede prepararlo online ahora') }}</strong>
    <p>{{ t('Envíe sus datos y documentos en unos minutos y la notaría le contactará para prepararlo.') }}</p>
    <NuxtLink :to="destino" class="adelantar-tramite__boton">
      {{ t('Empezar mi encargo online') }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAccesoSolicitud } from '../../composables/solicitudAcceso'
import { t } from '../../composables/solicitudTextos'

// precarga: el formulario de contacto dejó el trámite y los datos de contacto para el encargo (ver PRECARGA_ENCARGO)
const props = defineProps<{ tramite?: string | null; precarga?: boolean }>()
const acceso = useAccesoSolicitud()
const destino = computed(() => {
  const d = acceso.enlace('gracias', props.tramite)
  return props.precarga ? { ...d, query: { ...d.query, precarga: '1' } } : d
})
</script>

<style lang="scss">
.adelantar-tramite {
  margin: 24px auto 0; max-width: 520px; padding: 18px 20px; border-radius: 12px; text-align: center;
  background: #f5f7f9; border: 1px solid #e3e7ea; color: #1d2329;
  p { margin: 6px 0 14px; color: #5f6b76; font-size: 0.95rem; }
  &__boton {
    display: inline-flex; align-items: center; min-height: 44px; padding: 0 24px; border-radius: 999px;
    background: rgb(var(--v-theme-primary)); color: rgb(var(--v-theme-on-primary)) !important;
    font-weight: 600; text-decoration: none !important;
    &:hover, &:focus-visible { filter: brightness(1.08); }
  }
}
</style>
